import { render } from "./AccountTypeCreate.vue?vue&type=template&id=fdb81b30"
import script from "./AccountTypeCreate.vue?vue&type=script&lang=js"
export * from "./AccountTypeCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__